(function(){
  function toFloat(val){
    if (typeof val === 'number') return val;
    if (!val) return 0;
    try { return parseFloat(String(val).replace(/[^0-9.\-]/g, '')) || 0; } catch(e){ return 0; }
  }
  function getQueryParam(name){
    try {
      let params = new URLSearchParams(window.location.search);
      return params.get(name);
    } catch(e){ return null; }
  }
  function getHeaderText(){
    let h2 = document.querySelector('.number_plate_listing_header h2');
    if (h2 && h2.textContent) return h2.textContent.trim();
    let h2any = document.querySelector('h2');
    if (h2any && h2any.textContent) return h2any.textContent.trim();
    return '';
  }
  function deriveTermFromTitle(){
    let t = document.title || '';
    return t.replace(/\s*-\s*Page\s+\d+\s*/i, '').replace(/\s*\|.*/, '').trim();
  }
  function getSearchContext(anchors){
    let listId = 'search_page';
    let listName = '';
    let term = '';
    if (anchors.length > 0) {
      let a0 = anchors[0];
      listId = a0.getAttribute('data-list-id') || listId;
      listName = a0.getAttribute('data-list-name') || '';
    }
    if (!listName) {
      term = getQueryParam('search_key') || getHeaderText() || deriveTermFromTitle() || 'Search';
      listName = 'Search for: ' + term;
    }
    return { listId: listId, listName: listName };
  }
  function buildItems(anchors){
    let items = [];
    let idx = 0;
    anchors.forEach(function(a){
      let plate = a.getAttribute('data-plate') || (a.textContent || '').trim();
      if (!plate) return;
      let indexAttr = a.getAttribute('data-index');
      let index = (indexAttr !== null && indexAttr !== '') ? (parseInt(indexAttr, 10) || 0) : idx;
      let price = toFloat(a.getAttribute('data-price'));
      items.push({
        item_id: plate,
        item_name: plate,
        affiliation: 'Online Store',
        index: index,
        item_brand: 'National Numbers',
        price: price,
        quantity: 1
      });
      idx++;
    });
    return items;
  }
  function pushViewItemList(anchors){
    if (!window.dataLayer || !Array.isArray(window.dataLayer)) return;
    let ctx = getSearchContext(anchors);
    let items = buildItems(anchors);
    if (items.length === 0) return;
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'view_item_list',
      ecommerce: {
        item_list_id: ctx.listId,
        item_list_name: ctx.listName,
        items: items
      }
    });
  }
  function handleClick(e){
    let a = e.currentTarget;
    if (!a || !window.dataLayer || !Array.isArray(window.dataLayer)) return;
    let plate = a.getAttribute('data-plate') || (a.textContent || '').trim();
    let index = parseInt(a.getAttribute('data-index') || '0', 10) || 0;
    let price = toFloat(a.getAttribute('data-price'));
    let listId = a.getAttribute('data-list-id') || 'search_page';
    let listName = a.getAttribute('data-list-name') || getSearchContext([a]).listName;
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'select_item',
      ecommerce: {
        item_list_id: listId,
        item_list_name: listName,
        items: [{
          item_id: plate,
          item_name: plate,
          affiliation: 'Online Store',
          index: index,
          item_brand: 'National Numbers',
          price: price,
          quantity: 1,
          item_list_id: listId,
          item_list_name: listName
        }]
      }
    });
  }
  document.addEventListener('DOMContentLoaded', function(){
    try {
      let anchors = Array.prototype.slice.call(document.querySelectorAll('ul.number_plate_list a.number_plate'));
      if (anchors.length === 0) return;
      pushViewItemList(anchors);
      anchors.forEach(function(a){
        a.addEventListener('click', handleClick, { capture: true });
      });
    } catch(e) { /* soft fail */ }
  });
})();
